(() => {
  if (window.geHeaderAnnouncementLayout) return;
  window.geHeaderAnnouncementLayout = true;
  const desktop = window.matchMedia('(min-width: 1400px)');
  let bar, anchor;

  function restore() {
    if (anchor?.isConnected && bar) anchor.replaceWith(bar);
    anchor = null;
    bar = null;
  }

  function refreshRotators() {
    if (typeof window.geRefreshAnnouncementRotators === 'function') {
      window.geRefreshAnnouncementRotators();
    }
  }

  function sync() {
    restore();
    const slot = document.querySelector('[data-desktop-layout="centered_announcement"] [data-header-announcement]');
    const source = document.querySelector('.announcement-bar-section .announcement-bar');
    if (desktop.matches && document.body.classList.contains('ge-nav-horizontal') && slot && source) {
      bar = source;
      anchor = document.createComment('Announcement returns here on mobile or original layout');
      bar.replaceWith(anchor);
      slot.append(bar);
    }
    refreshRotators();
    window.dispatchEvent(new Event('resize'));
  }

  desktop.addEventListener('change', sync);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches('.header-section, .announcement-bar-section')) restore();
  });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:reorder', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
})();
